import { Component, Input, TemplateRef } from '@angular/core';
import { DayViewHourSegment } from '../../utils/day/DayViewHourSegment';
export class DayViewHourSegmentComponent {

   segment: DayViewHourSegment;

   segmentHeight: number;

   locale: string;

   customTemplate: TemplateRef<any>;

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'calendar-day-view-hour-segment',
  template: `
    <ng-template
    #defaultTemplate
    let-segment="segment"
    let-locale="locale">
    <div
      class="cal-hour-segment"
      [style.height.px]="segmentHeight"
      [class.cal-hour-start]="segment.isStart"
      [class.cal-after-hour-start]="!segment.isStart"
      [ngClass]="segment.cssClass">
      <div class="cal-time">
        {{ segment.date | date: 'h:mm a' }}
      </div>
    </div>
    </ng-template>
    <ng-template
    [ngTemplateOutlet]="defaultTemplate"
    [ngTemplateOutletContext]="{
      segment: segment,
      locale: locale
    }">
    </ng-template>
  `,
  styles: [`
    .cal-hour-segment{
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        border-bottom: 1px solid #EBEEF2;
        border-right: 1px solid #EBEEF2;
        border-left: 1px solid #EBEEF2;
    }
    .cal-hour-segment.cal-after-hour-start .cal-time {
        color: transparent;
        border-bottom: 1px solid #EBEEF2;

    }
    .cal-hour-segment .cal-time {    
        height: 30px;
        font-size: 12px;
        padding-left: 15px;
        border-right: 1px solid #EBEEF2;
        color: #555555;
    }


    .cal-hour-segment .cal-hour-segment-header:not(:last-child) {
        border-right: 1px solid #EBEEF2;
      }
    .cal-hour-segment .cal-time {
        position: absolute;
        width: 70px;
        left: 0;
    }
    .cal-hour-segment .cal-hour-segment-header {
        -webkit-box-flex: 1;
            -ms-flex: 1;
                flex: 1;
    } 
    .cal-hour-segment:hover {
        background-color: transparent;
    }

    .cal-hour-segment.cal-hour-start {
        border-bottom: none;
    }
  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'segment': [{ type: Input },],
'segmentHeight': [{ type: Input },],
'locale': [{ type: Input },],
'customTemplate': [{ type: Input },],
};
}

function DayViewHourSegmentComponent_tsickle_Closure_declarations() {
/** @type {?} */
DayViewHourSegmentComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DayViewHourSegmentComponent.ctorParameters;
/** @type {?} */
DayViewHourSegmentComponent.propDecorators;
/** @type {?} */
DayViewHourSegmentComponent.prototype.segment;
/** @type {?} */
DayViewHourSegmentComponent.prototype.segmentHeight;
/** @type {?} */
DayViewHourSegmentComponent.prototype.locale;
/** @type {?} */
DayViewHourSegmentComponent.prototype.customTemplate;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
